import { DisplayGroup } from '@common/components/forms/fields';
import { HospitalModel } from '@common/models';
import { observer } from "mobx-react";
import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface IProps {
    hospital: HospitalModel;
}

export const LocationDiagnosticDisplay = observer((props: IProps) => {
    return (
        <>
            <Row className="pt-4">
                <Col md={6}>
                    <DisplayGroup controlid={"diagnosticLabUserName"} text={"Diagnostic Lab Username"} value={props.hospital.diagnosticLabUserName} />
                </Col>
                <Col md={6}>
                    <DisplayGroup controlid={"diagnosticLabPassword"} text={"Diagnostic Lab Password"} value={props.hospital.diagnosticLabPassword} />
                </Col>
            </Row>
        </>
    )
});
